module.exports = __webpack_public_path__ + "static/media/arrow-left-light-blue.2e770da1.svg";